import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../../api/axios";
import { sleep } from "../../../../functions";
import DataContext from "./context";

export const useDataManager = () => {
  const [request, setRequest] = useState({
    loading: true,
    data: [],
    page: 0,
    limit: 100,
  });

  const getDataAll = useCallback(async () => {
    const mData = { ...request };
    try {
      request.loading = true;
      //showLoading();
      const { data: response, error } = await axios.get(
        `/users?&page=${request.page + 1}&limit=${request.limit}`,
      );

      if (error) throw new Error(error);

      const formattedData = response.data.map(
        ({ name, businessName, phone, address, ...p }, index) => ({
          ...p,
          id: p._id,
          name,
          businessName,
          phone,
          address,
          date: new Date(p.createdAt).toLocaleString(),
          updatedAt: new Date(p.updatedAt).toLocaleString(),
        }),
      );

      Object.assign(mData, { ...response, data: formattedData });
    } catch (e) {
      console.log(e);
      mData.data = [];
    } finally {
      mData.loading = false;
      await sleep(1000);
      setRequest(mData);
    }
  }, [request.page, request.limit]);

  const onNextPage = ({ page, pageSize }) => {
    if (request.loading) return;
    setRequest((o) => ({ ...o, page, loading: true, limit: pageSize }));
  };

  useEffect(() => {
    async function fetchdata() {
      return getDataAll();
    }

    fetchdata();
    return () => {};
  }, [getDataAll]);

  return {
    request,
    getDataAll,
    onNextPage,
  };
};

export const useData = () => useContext(DataContext);
